export default __webpack_public_path__ + "static/media/brr-money-printer.4e2302e4.gif";